import SourceMappingList from './SourceMappingList';

export default SourceMappingList;
